import React from "react";
import Router from "./routes";
import "./Styles/globals.css";
import { Toaster } from "react-hot-toast";
import LottieAnimation from "./Animations/LottieAnimation";
import ErrorBoundary from "./errorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <LottieAnimation />
        <Toaster
          position="top-center"
          toastStyle={{ zIndex: 9999 }}
          reverseOrder={false}
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
        <Router />
      </div>
    </ErrorBoundary>
  );
}

export default App;